module.exports = {"430381001":"望春门街道","430381002":"新湘路街道","430381003":"昆仑桥街道","430381004":"东山街道","430381100":"山枣镇","430381101":"栗山镇","430381102":"中沙镇","430381103":"虞塘镇","430381104":"潭市镇","430381105":"棋梓镇","430381106":"壶天镇","430381107":"翻江镇","430381108":"金石镇","430381109":"白田镇","430381110":"月山镇","430381111":"泉塘镇","430381112":"梅桥镇","430381113":"毛田镇","430381114":"龙洞镇","430381200":"东郊乡","430381202":"金薮乡","430381203":"育塅乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430381.json
// module id = 1673
// module chunks = 0